import React from 'react';
import ReactMarkdown from "react-markdown";

import work from "../json/work.json";

import sourcecode from "../images/source-code.svg";
import timergo from "../images/timergo.png";
import dooranet from "../images/dooranet.png";
import translation from "../images/translation.svg";
import office from "../images/office.svg";

function Work() {

    function buildImageLink(link) {
        const images = [["sourcecode", sourcecode], ["timergo", timergo], ["dooranet", dooranet], ["translation", translation], ["office", office]];
        for (let i = 0; i < images.length; i++) {
            if (images[i][0] === link) {
                
                return images[i][1];
            }
        }
    }

    function buildHeaderLink(href, title, text) {
        if (href.length) {
            return (
                <h2 className="subtitle"><a href={href} title={title} target="_blank" rel="noopener noreferrer">{text}</a></h2>
            )
        } else {
            return (
               <h2 className="subtitle">{text}</h2>
            )
        }
    }

    return (
        <div className="content">
            <header>
                <h1 className="title has-text-centered has-text-white">Work</h1>
                <p>The places where I have worked at and the products I have worked on, both in IT and otherwise.</p>
            </header>
            {work.work.map((w, index = 0) => {
                return (
                    <section className="section" key={index++}>
                        <div className="columns">
                            <div className="column is-narrow">
                                <figure>
                                    <img className="image is-128x128" src={buildImageLink(w.image.src)} alt={w.image.alt} />
                                </figure>
                            </div>
                            <div className="column">
                                <div className="content">
                                    {buildHeaderLink(w.link.href, w.link.title, w.link.text)}
                                    <ReactMarkdown children={w.body} />
                                </div>
                            </div>
                        </div>

                    </section>
                )
            })}
        </div>
    )
}

export default Work;